import React from "react";
import { Alert, Badge, Card, Col, Row } from "react-bootstrap";

const PERINGKAT = { T1: 1, T2: 2, T3: 3, T4: 4 };

// Tier yang lebih kecil berarti kualitas data lebih baik, jadi syarat terpenuhi
// bila peringkat data tidak lebih besar dari peringkat minimum yang diminta.
const memenuhi = (tierData, tierMinimum) => {
  if (!tierData || !tierMinimum) return null;
  return PERINGKAT[tierData] <= PERINGKAT[tierMinimum];
};

function TabPublishingRules({ indikatorList, baselineList }) {
  const aktif = (indikatorList || []).filter((val) => val.status !== "archived");

  const baselineAktif = (code) =>
    (baselineList || []).find(
      (val) => val.indicator_code === code && val.status === "active"
    );

  const jumlahPelanggan = aktif.filter((val) => val.visible_customer).length;

  return (
    <div>
      <Alert variant="secondary" style={{ fontSize: "11px" }}>
        Panel ini hanya menampilkan ringkasan aturan yang sudah melekat pada tiap
        indikator. Belum ada endpoint pengaturan global, sehingga tier minimum
        diubah lewat form indikator di tab Registry.
      </Alert>

      <Row className="g-2 mb-3">
        <Col xs={12} md={4}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-3">
              <div className="text-muted" style={{ fontSize: "11px" }}>
                Indikator tidak diarsipkan
              </div>
              <div className="fw-bold" style={{ fontSize: "22px" }}>
                {aktif.length}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={4}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-3">
              <div className="text-muted" style={{ fontSize: "11px" }}>
                Tampil ke pelanggan
              </div>
              <div className="fw-bold" style={{ fontSize: "22px" }}>
                {jumlahPelanggan}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={4}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-3">
              <div className="text-muted" style={{ fontSize: "11px" }}>
                Punya klaim penghematan
              </div>
              <div className="fw-bold" style={{ fontSize: "22px" }}>
                {aktif.filter((val) => val.has_saving).length}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="table-responsive">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Indikator</th>
              <th className="text-center">Status</th>
              <th className="text-center">Tier Minimum</th>
              <th className="text-center">Tier Baseline</th>
              <th className="text-center">Syarat Terpenuhi</th>
              <th className="text-center">Tampil Pelanggan</th>
              <th className="text-center">Cakupan</th>
            </tr>
          </thead>
          <tbody>
            {aktif.length > 0 ? (
              aktif.map((val) => {
                const baseline = val.baseline || baselineAktif(val.code);
                const tierData = baseline?.quality_tier;
                const lolos = val.has_saving
                  ? memenuhi(tierData, val.min_quality_tier_to_publish)
                  : null;

                return (
                  <tr key={val.id}>
                    <td>
                      <div className="fw-bold">{val.name_id}</div>
                      <div className="text-muted" style={{ fontSize: "10px" }}>
                        {val.code} · {val.kategori}
                      </div>
                    </td>
                    <td className="text-center">
                      <Badge
                        bg={
                          val.status === "active"
                            ? "success"
                            : val.status === "draft"
                            ? "warning"
                            : "dark"
                        }
                      >
                        {val.status}
                      </Badge>
                    </td>
                    <td className="text-center">
                      <Badge bg="secondary">
                        {val.min_quality_tier_to_publish}
                      </Badge>
                    </td>
                    <td className="text-center">
                      {tierData ? (
                        <Badge bg="info">{tierData}</Badge>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td className="text-center">
                      {lolos === null ? (
                        <span className="text-muted">tidak berlaku</span>
                      ) : lolos ? (
                        <Badge bg="success">Ya</Badge>
                      ) : (
                        <Badge bg="danger">Belum</Badge>
                      )}
                    </td>
                    <td className="text-center">
                      {val.visible_customer ? "Ya" : "Tidak"}
                    </td>
                    <td className="text-center">{val.display_scope}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="text-muted mt-2" style={{ fontSize: "10px" }}>
        Indikator penghematan yang syaratnya belum terpenuhi akan ditahan sistem dan
        tidak muncul pada dashboard, walaupun status definisinya sudah aktif.
      </div>
    </div>
  );
}

export default TabPublishingRules;
